import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import json from "react-syntax-highlighter/dist/esm/languages/hljs/json";
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python";

// Register the languages the export dialog highlights (side-effect on import).
// A mode's `ExportLanguageOption.highlighter` must be one of these ids.
SyntaxHighlighter.registerLanguage("python", python);
SyntaxHighlighter.registerLanguage("json", json);

export { SyntaxHighlighter };
export { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
